import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import { FaFingerprint } from "react-icons/fa";
import React from "react";

const StyledHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledProfileIcon = styled(FaFingerprint)(({ theme }) => ({
  marginLeft: 16,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
  fontSize: 24,
}));

const SettingsHeader = () => {
  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
          Profile
        </Typography>
        <StyledProfileIcon />
      </Box>
    </StyledHeader>
  );
};

export default SettingsHeader;
